export default __webpack_public_path__ + "static/media/fructose2.3125cef4.jpg";